<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card v-if="item.id">
      <v-card-title class="primary white--text">
        HỒ SƠ CHI TIẾT LỚP BÁN TRÚ
        <v-spacer />
        <v-btn dark icon>
          <v-icon @click="closeDialog">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row class="mt-4 py-3">
          <v-col class="py-0" cols="12">
            <v-row>
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Tên lớp bán trú</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ item.name }}</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Số lượng học sinh</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ item.studentCount }} / 30</p></v-col
              >

              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Số lượng giáo viên</p>
              </v-col>

              <v-col md="8"
                ><p class="mb-0">{{ item.teacherCount }} / 10</p></v-col
              >
              <v-col class="d-flex align-center py-0" cols="12" md="4">
                <p class="mb-0">Trạng thái</p>
              </v-col>
              <v-col md="8">
                <p class="mb-0">{{ item.status | busStatus }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="editState" class="ma-2" outlined color="#0D47A1">Sửa hồ sơ lớp bán trú</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({ dialog: false }),
  computed: {
    ...mapGetters('boardingClass', ['item']),
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    editState() {
      this.$emit('edit')
      this.dialog = false
    },
  },
}
</script>

<style>
p {
  color: black;
}
.v-subheader {
  width: 30%;
}
</style>
